module.exports = __webpack_public_path__ + "img/constant-learner.9cadca04.svg";